import { useAppStore } from "@/global/store";
import {
  gameFiltersState,
  selectPriceRange,
  selectPriceRangeSelected,
} from "@/global/store/data/gameFilters";
import { IOSSlider } from "@/shared/base/components/IOSSlider/IOSSlider";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import {
  Box,
  Divider,
  Grid,
  Stack,
  TextFieldProps,
  Typography,
  useTheme,
  colors,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";
import { useFilterPanelsState } from "../useFilterPanels";
import { filterPanelNames } from "@/global/config/constants";

export function PriceRangeSelector(props: { title?: string }) {
  const dispatch = useDispatch();
  const priceRange = useAppStore(selectPriceRange);
  const selected = useAppStore(selectPriceRangeSelected);
  const [value, setValue] = React.useState([0, 1000]);
  const { set: setFilterPanelsState } = useFilterPanelsState();

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const onFinishSelect = (event: any, newValue: any) => {
    dispatch(
      gameFiltersState.actions.setByKeys({
        keys: ["priceRange", "selected"],
        value: newValue,
      })
    );
    setFilterPanelsState({
      lastChangedFilter: filterPanelNames.price_selector,
    });
  };

  useEffect(() => {
    setValue(selected);
  }, [selected]);

  return (
    <Box>
      {props?.title ? (
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={"700"}
            color="text.primary"
          >
            {props?.title}
          </Typography>
        </Box>
      ) : null}

      {/* <Box mb={-2} mt={2}>
        <PriceChart />
      </Box> */}
      <Box>
        <IOSSlider
          disableSwap
          getAriaLabel={() => "Price Range"}
          value={value}
          min={priceRange.min}
          max={priceRange.max}
          onChange={handleChange}
          onChangeCommitted={onFinishSelect}
        />
      </Box>
      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={5.5}>
            <PriceInput value={value[0]} />
          </Grid>
          <Grid item xs={1}>
            <Stack justifyContent={"center"} width={"100%"} height="100%">
              <Divider />
            </Stack>
          </Grid>
          <Grid item xs={5.5}>
            <PriceInput value={value[1]} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

function createPriceChartData(count: number, limit: number) {
  let results = [];
  for (let i = 1; i <= count; i++) {
    results.push({
      value: Math.abs(Math.sin((2 * Math.PI * i) / count) * limit),
    });
  }
  return results;
}

const PriceChart = () => {
  const { md: mdDown, sm: smDown } = useCssMediaQuery("down");
  const price_chart_data = createPriceChartData(smDown ? 24 : 50, 80);

  return (
    <Stack
      direction={"row"}
      height={"80px"}
      width={"100%"}
      alignItems={"flex-end"}
      spacing={"6px"}
    >
      {price_chart_data.map((itm) => {
        return (
          <Box
            key={uuid()}
            sx={{
              backgroundColor: colors.grey[300],
              width: smDown ? "9px" : "12px",
              height: `${itm.value}px`,
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          />
        );
      })}
    </Stack>
  );
};

const PriceInput = (props: TextFieldProps) => {
  const theme = useTheme();
  return (
    <Box border={`1px solid ${theme.palette.divider}`} p={1} borderRadius={0.5}>
      <Typography variant="subtitle1">${props?.value as string}</Typography>
    </Box>
  );
};
